import React from 'react';

export default function Image(props) {
  const { src, credit, location, title, width, height } = props;

  let leftText = '';
  if (title !== '') {
    leftText = `${title}`;
  }

  return (
    <div className="image-wrap">
      <img
        src={src}
        alt={location}
        width={width}
        height={height}
        loading="lazy"
        className="galleryImage"
      />
      <div className="image-text-bot">
        <div className="image-count">{leftText}</div>
        <div className="image-credit">{credit}</div>
      </div>
    </div>
  );
}
